import { render, staticRenderFns } from "./noticeReadonlyContents.vue?vue&type=template&id=76c8d8cc&"
import script from "./noticeReadonlyContents.vue?vue&type=script&lang=ts&"
export * from "./noticeReadonlyContents.vue?vue&type=script&lang=ts&"
import style0 from "./noticeReadonlyContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports